import React from 'react';
import { siteContent } from '../data/mock';

const Problem = () => {
  const { problem } = siteContent;

  return (
    <section className="py-24 bg-neutral-50">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-medium text-neutral-900 mb-12">
          {problem.title}
        </h2>
        <div className="space-y-6 text-lg text-neutral-700 leading-relaxed">
          {problem.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
        <div className="mt-10 mb-10">
          <p className="text-lg text-neutral-700 mb-4">The result:</p>
          <ul className="space-y-2">
            {problem.results.map((result) => (
              <li key={result} className="text-lg text-neutral-700">— {result}</li>
            ))}
          </ul>
        </div>
        <p className="text-lg text-neutral-700 leading-relaxed">
          {problem.conclusion}
        </p>
        </div>
      </div>
    </section>
  );
};

export default Problem;
